import moment from "moment";
import { addLocale } from "primereact/api";
import { allHolidays } from "./holidaysHelper";

export const germanDateFormat = "DD.MM.yy";

export const getDateFormatted = (
  date: Date | null,
  format?: string,
): string | null => {
  const sentDate = moment(date);

  if (sentDate.isValid()) {
    if (format) {
      return sentDate.format(format);
    }

    return sentDate.format(germanDateFormat);
  }

  return null;
};

export const getDateTimeISOFormatted = (
  isoString: string | null,
): string | null => {
  if (!isoString) return null;

  const date = new Date(isoString);

  if (isNaN(date.getTime())) return null;

  const day = String(date.getUTCDate()).padStart(2, "0");
  const month = String(date.getUTCMonth() + 1).padStart(2, "0"); // +1 because months are 0-based
  const year = date.getUTCFullYear();

  const hours = String(date.getUTCHours() + 1).padStart(2, "0");
  const minutes = String(date.getUTCMinutes()).padStart(2, "0");

  return `${day}.${month}.${year} ${hours}:${minutes}`;
};

export const getTimeFromIsoDate = (isoDate: string) => {
  const date = new Date(isoDate);
  return date.toTimeString().slice(0, 5);
};

export const daysFromCheckinUntilNow = (
  checkinDate: Date,
  endDate: Date = new Date(),
): number => moment(endDate).diff(moment(checkinDate), "days") + 1;

export const getLastDateOfMonth = (currentDate: Date) => {
  const year = currentDate.getFullYear();
  const month = currentDate.getMonth() + 1;
  return new Date(year, month, 0);
};

export const getPlannedDateColor = (inputDate: Date): string | null => {
  if (!moment(inputDate)?.isValid()) {
    return null;
  }

  const today = new Date();
  const currentMonth = today.getMonth() + 1;
  const currentYear = today.getFullYear();

  const sentDate = new Date(inputDate);

  const inputMonth = sentDate.getMonth() + 1;
  const inputYear = sentDate.getFullYear();

  if (inputYear === currentYear) {
    if (inputMonth < currentMonth) {
      return "red";
    } else if (inputMonth === currentMonth) {
      return "green";
    }
  } else if (inputYear < currentYear) {
    return "red";
  }

  return null;
};

export const getHolidays = () => allHolidays;

export const getGermanCalenderConfig = () =>
  addLocale("de", {
    firstDayOfWeek: 1,
    dayNames: [
      "Sonntag",
      "Montag",
      "Dienstag",
      "Mittwoch",
      "Donnerstag",
      "Freitag",
      "Samstag",
    ],
    dayNamesShort: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
    dayNamesMin: ["S", "M", "D", "M", "D", "F", "S"],
    monthNames: [
      "Januar",
      "Februar",
      "März",
      "April",
      "Mai",
      "Juni",
      "Juli",
      "August",
      "September",
      "Oktober",
      "November",
      "Dezember",
    ],
    monthNamesShort: [
      "Jan",
      "Feb",
      "Mär",
      "Apr",
      "Mai",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Okt",
      "Nov",
      "Dez",
    ],
    today: "Heute",
    clear: "Löschen",
    dateFormat: "dd.mm.yy",
  });

export const germanLocale = {
  firstDayOfWeek: 1,
  dayNames: [
    "Sonntag",
    "Montag",
    "Dienstag",
    "Mittwoch",
    "Donnerstag",
    "Freitag",
    "Samstag",
  ],
  dayNamesShort: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
  dayNamesMin: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
  monthNames: [
    "Januar",
    "Februar",
    "März",
    "April",
    "Mai",
    "Juni",
    "Juli",
    "August",
    "September",
    "Oktober",
    "November",
    "Dezember",
  ],
  monthNamesShort: [
    "Jan",
    "Feb",
    "Mär",
    "Apr",
    "Mai",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Okt",
    "Nov",
    "Dez",
  ],
  today: "Heute",
  clear: "Löschen",
  dateFormat: "dd.mm.yy",
  weekHeader: "KW",
  selectionMessage: "{0} ausgewählt",
};

export const sameHourMinute = (a?: Date, b?: Date): boolean => {
  if (!a || !b) {
    return false;
  }

  return (
    a.getFullYear() === b.getFullYear() &&
    a.getMonth() === b.getMonth() &&
    a.getDate() === b.getDate() &&
    a.getHours() === b.getHours() &&
    a.getMinutes() === b.getMinutes()
  );
};
